import React from 'react';
import { hasFeatureFlags } from 'utils/features';

const FeatureFlag = ({ features = [], fallback = null, children = null }) => {
  return hasFeatureFlags(features) ? children : fallback;
};

export default FeatureFlag;
export function withFeatureFlag(Component, features = [], fallback = null) {
  return props => (
    <FeatureFlag features={features} fallback={fallback}>
      <Component {...props} />
    </FeatureFlag>
  );
}
